//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: '',
  data () {
    return {
      note: ''
    }
  },
  created () {
    this.note = window.localStorage.getItem('note') ? window.localStorage.getItem('note') : ''
  },
  watch: {
    note (val) {
      window.localStorage.setItem('note', val)
    }
  },
  methods: {
    // saveNote (val) {
    //   window.localStorage.setItem('note', val)
    // }
  }
}



// WEBPACK FOOTER //
// ./src/views/layout/components/RightLayer/Note.vue